export default (Store) => {
    let store = null;
    return function () {
        if (store === null) {
            store = new Store();
        }
        return store;
    };
};
